import { LoadListParams } from 'app/area/code-mappings/components/types';
import { AccessCodetable, CodeMappingsListItems, CodetableMetadata, ModifiedCodeMappings } from 'app/area/code-mappings/types-store';
import { CodeComplexValue } from 'app/area/shared/codetable/types';
import { ComplexValue, LoadOptions } from 'app/types-shared';
import { ValidationProps } from 'ui';

export const ACTION = {
  REQUEST_LIST: 'CODE_MAPPINGS:REQUEST_LIST',
  RECEIVE_LIST: 'CODE_MAPPINGS:RECEIVE_LIST',
  FAIL_LIST: 'CODE_MAPPINGS:FAIL_LIST',
  CLEAR_LIST: 'CODE_MAPPINGS:CLEAR_LIST',
  
  REQUEST_ITEM: 'CODE_MAPPINGS:REQUEST_ITEM',
  RECEIVE_ITEM: 'CODE_MAPPINGS:RECEIVE_ITEM',
  FAIL_ITEM: 'CODE_MAPPINGS:FAIL_ITEM',

  MODIFY_ITEM: 'CODE_MAPPINGS:MODIFY_ITEM',
  COPY_TO_ALL: 'CODE_MAPPINGS:COPY_TO_ALL',

  REQUEST_SAVE_CHANGES: 'CODE_MAPPINGS:REQUEST_SAVE_CHANGES',
  RECEIVE_SAVE_CHANGES: 'CODE_MAPPINGS:RECEIVE_SAVE_CHANGES',
  FAIL_SAVE_CHANGES: 'CODE_MAPPINGS:FAIL_SAVE_CHANGES',

  REQUEST_CODETABLE_OPTIONS: 'CODE_MAPPINGS:REQUEST_CODETABLE_OPTIONS',
  RECEIVE_CODETABLE_OPTIONS: 'CODE_MAPPINGS:RECEIVE_CODETABLE_OPTIONS',
  FAIL_CODETABLE_OPTIONS: 'CODE_MAPPINGS:FAIL_CODETABLE_OPTIONS',

  VALIDATION_CHANGE: 'CODE_MAPPINGS:VALIDATION_CHANGE',
  CLEAR_VALIDATION: 'CODE_MAPPINGS:CLEAR_VALIDATION',
  RESET_VALIDATION: 'CODE_MAPPINGS:RESET_VALIDATION',

  REQUEST_ACCESS_CODETABLES: 'CODE_MAPPINGS:REQUEST_ACCESS_CODETABLES',
  RECEIVE_ACCESS_CODETABLES: 'CODE_MAPPINGS:RECEIVE_ACCESS_CODETABLES',
  FAIL_ACCESS_CODETABLES: 'CODE_MAPPINGS:FAIL_ACCESS_CODETABLES',

  REQUEST_METADATA: 'CODE_MAPPINGS:REQUEST_METADATA',
  RECEIVE_METADATA: 'CODE_MAPPINGS:RECEIVE_METADATA',
  FAIL_METADATA: 'CODE_MAPPINGS:FAIL_METADATA'
};

export class RequestList {
  public type: string = ACTION.REQUEST_LIST;
  constructor(public requestId: number) { }
}

export class ReceiveList {
  public type: string = ACTION.RECEIVE_LIST;
  constructor(
    public requestId: number,
    public params: LoadListParams,
    public codetableIds: string[],
    public fileName: ComplexValue<number>,
    public importSet: ComplexValue<number>,
    public missingMappingsExists: boolean,
    public list: CodeMappingsListItems[]) { }
}

export class FailList {
  public type: string = ACTION.FAIL_LIST;
  constructor(public requestId: number) { }
}

export class ClearList {
  public type: string = ACTION.CLEAR_LIST;
  constructor(public requestId: number) { }
}

export class RequestItem {
  public type: string = ACTION.REQUEST_ITEM;
  constructor(public requestId: number, public params: LoadListParams) { }
}

export class ReceiveItem {
  public type: string = ACTION.RECEIVE_ITEM;
  constructor(
    public requestId: number,
    public params: LoadListParams,
    public list: CodeMappingsListItems[]) { }
}

export class FailItem {
  public type: string = ACTION.FAIL_ITEM;
  constructor(public requestId: number) { }
}

export class ModifyItem {
  public type: string = ACTION.MODIFY_ITEM;
  constructor(public modifiedData: ModifiedCodeMappings) { }
}

export class CopyToAll {
  public type: string = ACTION.COPY_TO_ALL;
  constructor(
    public id: string,
    public codetableId: number,
    public code: ComplexValue<number>,
    public codeCategory: ComplexValue<number>) { }
}

export class RequestSaveChanges {
  public type: string = ACTION.REQUEST_SAVE_CHANGES;
  constructor() { }
}

export class ReceiveSaveChanges {
  public type: string = ACTION.RECEIVE_SAVE_CHANGES;
  constructor() { }
}

export class FailSaveChanges {
  public type: string = ACTION.FAIL_SAVE_CHANGES;
  constructor() { }
}

export class RequestCodetableOptions {
  public type: string = ACTION.REQUEST_CODETABLE_OPTIONS;
  constructor(public id: string, public loadOptionsParams: LoadOptions) {
  }
}

export class ReceiveCodetableOptions {
  public type: string = ACTION.RECEIVE_CODETABLE_OPTIONS;

  constructor(
    public id: string,
    public loadOptionsParams: LoadOptions,
    public codes: CodeComplexValue<number>[],
    public currentOptions: CodeComplexValue<number>[]) {
  }
}

export class FailCodetableOptions {
  public type: string = ACTION.FAIL_CODETABLE_OPTIONS;

  constructor(public id: string, public loadOptionsParams: LoadOptions) {
  }
}

export class ValidationChange {
  public type: string = ACTION.VALIDATION_CHANGE;

  constructor(public validation: { [key: string]: ValidationProps }) { }
}

export class RequestAccessCodetables {
  public type: string = ACTION.REQUEST_ACCESS_CODETABLES;
  constructor(public id: number) {
  }
}

export class ReceiveAccessCodetables {
  public type: string = ACTION.RECEIVE_ACCESS_CODETABLES;
  constructor(public id: number, public accessCodetables: AccessCodetable) {
  }
}

export class FailAccessCodetables {
  public type: string = ACTION.FAIL_ACCESS_CODETABLES;
  constructor(public id: number) {
  }
}

export class RequestMetadata {
  public type: string = ACTION.REQUEST_METADATA;
  constructor(public id: number) {
  }
}

export class ReceiveMetadata {
  public type: string = ACTION.RECEIVE_METADATA;
  constructor(public id: number, public metadata: CodetableMetadata) {
  }
}

export class FailMetadata {
  public type: string = ACTION.FAIL_METADATA;
  constructor(public id: number) {
  }
}
